import { createEffect, createEvent, createStore, sample } from 'effector';
import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { Org, OrgCoupons } from '@nx-frontend/shared/types';

export const initialOrgCouponsState: OrgCoupons = {
  isLoaded: false,
  isFetching: false,
  couponNumber: {},
};

export const $orgCoupons = createStore<OrgCoupons>(initialOrgCouponsState);

export const loadOrgCouponsEvent = createEvent<Org>();
const setOrgCouponsFetchingEvent = createEvent();

const loadOrgCouponsFx = createEffect(async ({ orgId }: { orgId: string }) => {
  const { data } = await axiosClient.get<OrgCoupons>(`${generalEnv.nextApiPath}/orgs/${orgId}/coupons`);
  return data;
});

$orgCoupons.on(setOrgCouponsFetchingEvent, (store) => {
  if (store.isFetching || store.isLoaded) {
    return store;
  }
  return Object.assign({}, store, {
    isFetching: true,
  });
});

$orgCoupons.on(loadOrgCouponsFx.doneData, (orgCoupons, data) => {
  return Object.assign({}, orgCoupons, {
    couponNumber: data.couponNumber,
    isLoaded: true,
    isFetching: false,
  });
});

$orgCoupons.on(loadOrgCouponsFx.failData, (orgCoupons, data) => {
  console.error('Fail to fetch org coupons', data);
  return Object.assign({}, orgCoupons, {
    isFetching: false,
  });
});

export const $isCouponLoaded = $orgCoupons.map((orgCoupons) => {
  if (!orgCoupons) {
    return false;
  }
  return orgCoupons.isLoaded;
});

export const $hasCoupons = $orgCoupons.map((orgCoupons) => {
  if (!orgCoupons.couponNumber) {
    return false;
  }

  if (typeof orgCoupons.couponNumber !== 'object') {
    return false;
  }

  return Object.keys(orgCoupons.couponNumber).length;
});

sample({
  source: $orgCoupons,
  clock: loadOrgCouponsEvent,
  filter(orgCoupons, currentOrganization) {
    if (orgCoupons.isFetching || orgCoupons.isLoaded || !currentOrganization || !currentOrganization.globalId) {
      // do not load if already fetching or loaded
      return false;
    }
    return true;
  },
  fn: (orgCoupons, currentOrganization) => {
    return {
      orgId: currentOrganization.globalId,
    };
  },
  target: [loadOrgCouponsFx, setOrgCouponsFetchingEvent],
});
